import { Injectable } from '@angular/core';
import { CommandService } from './command.service';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class BatteryService extends CommandService {
  constructor() {
    super(new ToastController());
  }

  sendMessage() {
    this.cmd = '3A14';

    console.log('BATTERY 3a14');

    this.ble
      .write(
        this.device.bleId,
        this.device.serviceUUID,
        this.device.rxUUID,
        this.hexTobytes(this.cmd)
      )
      .then(
        (data) => {
          console.log('Batterie: Cmd envoyée.');
        },
        (err) => {
          console.log(err);
        }
      );
  }

  public receiveResponse(data: any) {
    console.log('Battery : ', this.buf2hex(data));
    let value = this.buf2hex(data);
    value = value.substring(2, value.length);
    console.log('Value step 2 ', value);
    value = this.littleToBigEndian(value);
    console.log('Value step 3 ', value);
    value = parseInt(value, 16);
    console.log('Value step 4 ', value);
    value = Math.round(value * 1.61);
    console.log('Value step 5 ', value);
    return value;
  }
}
